import { Component, Fragment, h, Listen, Prop } from '@stencil/core';
import {
  iconPP,
  iconPPP,
  iconPrepayment,
  iconReservation,
  iconIdeal,
  iconCreditCard,
  iconSepa,
  iconSofort,
  iconBancontact,
  iconGiftcard,
  iconBlik,
  iconPrzelewy24, iconExpressCheckout,
} from '../icons';
import { t } from '../../../redux/utils';
import { PaymentMethod } from '../../../redux/types';
import { PaymentOption } from '../utils/types';
import { SelectOption } from '../../../types/types';

@Component({
  tag: 'rtr-payment-options',
  styleUrl: '../style.sass',
  shadow: false,
})
export class RtrPaymentOptions {
  @Prop() paymentOptions: SelectOption[];
  @Prop() currentMethod: PaymentMethod;
  @Prop() hasSecondaryPayment: boolean; // used for determine validation error
  @Prop() showPaymentOptions: boolean;
  @Prop() allowChange: boolean;
  @Prop() validationOptionsError: boolean;
  @Prop() onOptionChange: (item: SelectOption) => void;
  @Prop() onShowChangeMethod: () => void;

  private optionsEl: HTMLDivElement;

  componentDidLoad() {
    if (!this.currentMethod && this.paymentOptions?.length === 1) {
      this.onOptionChange(this.paymentOptions[0]);
    }

    if (this.validationOptionsError) {
      this.optionsEl?.scrollIntoView({ behavior: 'smooth' });
    }
  }

  @Listen('rtrPaymentOptionsNotValidated', { capture: true, target: 'body' })
  async scrollToError() {
    this.optionsEl?.scrollIntoView({ behavior: 'smooth' });
  }

  get optionsClass() {
    if (this.validationOptionsError && !this.hasSecondaryPayment) {
      // if secondary method exist this component is only passing this method and this errors is also not for this component
      return 'RTPOptionsContainer RTPOptionError';
    }

    return 'RTPOptionsContainer';
  }

  get showChooseText(): boolean {
    return this.paymentOptions?.length > 1;
  }

  get chooseMethodText(): string {
    return t('payment.chooseMethod');
  }

  get methodTitleText(): string {
    return t('payment.methodTitle');
  }

  get changeMethodText(): string {
    return t('payment.changeMethod');
  }

  mappedPaymentOption = item => {
    const label = [PaymentOption.PayPalPlus, PaymentOption.PayPalCheckout, PaymentOption.StripeExpressCheckout].includes(item.value) ? ' ' : item.label;

    const onRadioClick = (e: Event) => {
      e?.preventDefault();
      this.onOptionChange(item);
    };

    return (
      <label class={'RTPItemLabelContainer ' + item.value}>
        <rentware-radio
          name="paymentMethodOption"
          label={label}
          value={item.value}
          checked={this.currentMethod && this.currentMethod.value === item.value}
          onClick={onRadioClick}
        />

        <div class="RTPSVGContainer">
          {item.value === PaymentOption.PayPal && iconPP()}
          {item.value === PaymentOption.PayPalPlus && iconPPP()}
          {item.value === PaymentOption.PayPalCheckout && iconPPP()}
          {item.value === PaymentOption.Prepayment && iconPrepayment()}
          {item.value === PaymentOption.Reservation && iconReservation()}
          {item.value === PaymentOption.StripeIdeal && iconIdeal()}
          {item.value === PaymentOption.StripeCC && iconCreditCard()}
          {item.value === PaymentOption.StripeSepa && iconSepa()}
          {item.value === PaymentOption.StripeSofort && iconSofort()}
          {item.value === PaymentOption.StripeBanContact && iconBancontact()}
          {item.value === PaymentOption.StripeBlik && iconBlik()}
          {item.value === PaymentOption.StripeP24 && iconPrzelewy24()}
          {item.value === PaymentOption.StripeExpressCheckout && iconExpressCheckout()}
          {item.value === PaymentOption.GiftCard && iconGiftcard()}
        </div>
      </label>
    );
  };

  render() {
    let currentLabel: any = this.currentMethod?.label
    if (this.currentMethod?.value && [PaymentOption.PayPalPlus as string, PaymentOption.PayPalCheckout as string].includes(this.currentMethod.value)) {
      currentLabel = iconPPP()
    }
    if (this.currentMethod?.value === PaymentOption.StripeExpressCheckout) {
      currentLabel = iconExpressCheckout()
    }

    return (
      <Fragment>
        <div class="RTPOptionsTitle" id="Method">
          {this.methodTitleText}
        </div>

        {/*Please select a payment method to continue*/}
        {this.showPaymentOptions && this.showChooseText && this.chooseMethodText}

        {(this.showPaymentOptions && (
          <div
            class={this.optionsClass}
            ref={el => {
              this.optionsEl = el;
            }}
          >
            <rentware-spacer size="S" />

            {this.paymentOptions.map(this.mappedPaymentOption)}
          </div>
        )) || (
          <div
            class={this.optionsClass}
            ref={el => {
              this.optionsEl = el;
            }}
          >
            <div class="RTPOnePaymentContainer">
              <div class="SelectedMethodText">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="20" height="20" rx="10" fill="#46435B" />
                  <rect x="8" y="8" width="4" height="4" rx="2" fill="white" />
                </svg>

                {currentLabel}
              </div>

              {this.allowChange && this.showChooseText && (
                <div class="ChangeMethodLink" onClick={this.onShowChangeMethod}>
                  {this.changeMethodText}
                </div>
              )}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}
